export { TestimonialItem } from "./TestimonialItem";
export type { TestimonialItemData, TestimonialItemProps } from "./TestimonialItem";
